export default __webpack_public_path__ + "static/media/page.5b940711.png";